import { useState } from 'react';
import { MuellIcon, PfeilLinksIcon, PfeilRechtsIcon, PlusIcon } from '../icons';
import { SignaturFeld } from './SignaturFeld';
import { BETEILIGTER_ROLLE_LABEL, BETEILIGTER_ROLLEN, type Beteiligter, type Protokoll } from '../domain/types';

interface UnterschriftenProps {
	protokoll: Protokoll;
	onAendern: (protokoll: Protokoll) => void;
	onWeiter: () => void;
	onZurueck: () => void;
}

export function Unterschriften({ protokoll, onAendern, onWeiter, onZurueck }: UnterschriftenProps) {
	const [name, setName] = useState('');
	const [rolle, setRolle] = useState<Beteiligter['rolle']>('uebergeber');

	function hinzufuegen() {
		const bereinigt = name.trim();
		if (!bereinigt) return;
		const beteiligter: Beteiligter = { id: crypto.randomUUID(), name: bereinigt, rolle };
		onAendern({ ...protokoll, beteiligte: [...protokoll.beteiligte, beteiligter] });
		setName('');
	}

	function entfernen(id: string) {
		onAendern({ ...protokoll, beteiligte: protokoll.beteiligte.filter((b) => b.id !== id) });
	}

	function unterschriftAendern(id: string, unterschrift: string | undefined) {
		onAendern({
			...protokoll,
			beteiligte: protokoll.beteiligte.map((b) => (b.id === id ? { ...b, unterschrift } : b))
		});
	}

	return (
		<div className="schritt schritt--unterschriften">
			<div className="schritt-kopf">
				<h2>Wer ist dabei?</h2>
				<p className="schritt-erklaerung">Beteiligte erfassen und direkt auf dem Gerät unterschreiben lassen.</p>
			</div>

			<div className="beteiligter-formular">
				<input
					value={name}
					onChange={(e) => setName(e.target.value)}
					onKeyDown={(e) => e.key === 'Enter' && hinzufuegen()}
					placeholder="Name"
					className="beteiligter-name-feld"
				/>
				<select value={rolle} onChange={(e) => setRolle(e.target.value as Beteiligter['rolle'])} className="beteiligter-rolle-feld">
					{BETEILIGTER_ROLLEN.map((r) => (
						<option key={r.rolle} value={r.rolle}>
							{r.label}
						</option>
					))}
				</select>
				<button type="button" className="icon-knopf icon-knopf--akzent" onClick={hinzufuegen} aria-label="Person hinzufügen">
					<PlusIcon width={18} height={18} />
				</button>
			</div>

			{protokoll.beteiligte.length === 0 && (
				<p className="hinweis">Noch niemand erfasst. Name eingeben und hinzufügen, dann kann direkt unterschrieben werden.</p>
			)}

			<div className="signatur-liste">
				{protokoll.beteiligte.map((b) => (
					<div key={b.id} className="signatur-liste-eintrag">
						<div className="signatur-liste-entfernen">
							<button type="button" className="icon-knopf" onClick={() => entfernen(b.id)} aria-label={`${b.name} entfernen`}>
								<MuellIcon width={14} height={14} />
							</button>
						</div>
						<SignaturFeld
							name={`${b.name} · ${BETEILIGTER_ROLLE_LABEL[b.rolle]}`}
							wert={b.unterschrift}
							onAendern={(wert) => unterschriftAendern(b.id, wert)}
						/>
					</div>
				))}
			</div>

			<footer className="schritt-fuss">
				<button type="button" className="nebenknopf" onClick={onZurueck}>
					<PfeilLinksIcon width={18} height={18} />
					Zurück
				</button>
				<button type="button" className="hauptknopf hauptknopf--mit-icon" onClick={onWeiter}>
					Zum Dokument
					<PfeilRechtsIcon width={20} height={20} />
				</button>
			</footer>
		</div>
	);
}
